import React from 'react';
import HelpCenterArticle from 'views/HelpCenterArticle';

const HelpCenterArticlePage = () => {
  return <HelpCenterArticle />;
};

export default HelpCenterArticlePage;